<template>
  <div>

    <div class="card text-dark">
      <div class="card-body">

      <table class="table">
        <tbody>

        <template v-for="(leg, legIndex) in selectedTrip.legs">
          <tr :tabindex="0"
              :key="legIndex"
              @keyup.enter="legClickHandler(legIndex, 0)"
              @click="legClickHandler(legIndex, 0)"
              @mouseenter="legMouseoverHandler(legIndex, 0)"
              @mouseleave="legMouseoverHandler(-1)">
            <td class="start-time">
              {{ leg.startTime | epoch2TimeFormat }}
            </td>
            <td class="circle-line">
              <div class="circle-line-divwrapper">
                <div class="circle"></div>
                <div class="line" :class="'line-'+leg.mode.toLowerCase()"></div>
              </div>
            </td>
            <td>
              <template v-if="legIndex === 0">
              Start from<br> {{ leg.from.name }}
              </template>
              <template v-else>
              Arrive at<br> {{ leg.from.name }}
              </template>
              <div v-if="leg.transitLeg" class="mt-3">
                Depart on<br>

                <div class="mode-details" @click.stop="viewRouteDetails(leg.mode, leg.routeShortName)">
                  <span v-if="leg.modeIcon" :class="leg.modeIcon.class"></span>
                  <span v-else>{{ leg.mode }}</span>
                  <span class="line-no" v-if="leg.routeShortName">{{ leg.routeShortName }}</span>
                </div>

                <div>Towards {{ leg.headsign }}</div>
                <div @click="showLegSteps(legIndex)">
                  {{ leg.duration | durationFormat }}, {{ leg.intermediateStops.length }} stops
                  <span class="icon-icon-triangle-down-grey" :class="{ 'rotate180': legStepsToggled[legIndex] }" v-if="leg.intermediateStops.length > 0"></span>
                </div>
              </div>
              <div v-else class="mt-3">
                <span v-if="leg.modeIcon" :class="leg.modeIcon.class"></span> {{ leg.mode | capitalize }}
                <div @click="showLegSteps(legIndex)">
                  {{ leg.duration | durationFormat }}, {{ leg.distance | distanceFormat }}
                  <span class="icon-icon-triangle-down-grey" :class="{ 'rotate180': legStepsToggled[legIndex] }"></span>
                </div>
                <template v-if="leg.steps && legStepsToggled[legIndex]">
                <ul class="list-group leg-steps">
                  <li v-for="step in leg.steps" class="list-group-item">
                  <template v-if="step.relativeDirection === 'DEPART'">{{ leg.mode | capitalize }}</template>
                   {{ step.absoluteDirection | capitalize }} on {{ step.streetName }}
                  </li>
                </ul>
                </template>


              </div>
            </td>
          </tr>

          <!-- toggle intermediateStops -->
          <template v-if="leg.intermediateStops && legStepsToggled[legIndex]">
          <tr class="leg-steps" v-for="stop in leg.intermediateStops">
            <td class="start-time">{{ stop.arrival | epoch2TimeFormat }}</td>
            <td class="circle-line">
              <div class="circle-line-divwrapper">
                <div class="circle"></div>
                <div class="line" :class="'line-'+leg.mode.toLowerCase()"></div>
              </div>
            </td>
            <td>{{ stop.name }}</td>
          </tr>
          </template>

        </template>


          <!-- last leg -->
          <tr v-if="lastLeg">
            <td class="start-time">
              {{ lastLeg.endTime | epoch2TimeFormat }}
            </td>
            <td class="circle-line">
              <div class="circle-line-divwrapper">
                <div class="circle"></div>
              </div>
            </td>
            <td>Arrive at<br>{{ lastLeg.to.name }}</td>
          </tr>

        </tbody>
      </table>

      </div>
    </div>


  </div>
</template>

<script>

// import DepartArriveOptions from './DepartArriveOptions'
import mixinCommon from '../mixins/common'
import mixinFilters from '../mixins/filters'


export default {
  name: 'trip-planner-results-details',
  // components: { AddressField, SwapOrigDest, TimePicker, DatePicker, DepartArriveOptions, ModeSelections },
  // props: {
  //   msg: String
  // },
  mixins: [mixinCommon, mixinFilters],
  data () {
    return {
      legStepsToggled: []
    }
  },
  computed: {
    summary () { // get router params and query
      return this.$store.getters['tripPlanner/tripSummary'];
    },
    routes () { // get router params and query
      return this.$store.getters['tripPlanner/tripRoutes'];
    },
    selectedTripIndex () {
      return parseInt(this.$store.getters['tripPlanner/selectedTripIndex'])
    },
    selectedTrip () {
      if (this.selectedTripIndex < 0) {
        return false
      }
      if (this.routes.length < 1) {
        return false
      }
      if (!this.routes[this.selectedTripIndex]) {
        return false
      }
      return this.routes[this.selectedTripIndex]
    },
    legs () {
      if (!this.selectedTrip) {
        return false
      }
      return this.selectedTrip.legs
    },
    lastLeg () {
      if (!this.selectedTrip) {
        return false
      }
      if (!this.selectedTrip.legs) {
        return false
      }
      return this.selectedTrip.legs[this.selectedTrip.legs.length-1]
    }
  },
  watch: {
    legs (legs) {
      if (legs) {
        this.legStepsToggled = legs.map(x => false)
      }
    }
  },
  methods: {
    legClickHandler (legIndex) {
      console.log("legIndex", legIndex)
      this.$store.commit('tripPlanner/SET_SELECTED_LEG_INDEX', legIndex)
    },
    legMouseoverHandler () {

    },
    viewRouteDetails (mode, routeNo) {
      let routeType = (mode.toLowerCase() === 'bus') ? 'bus' : 'lightrail'
      this.$router.push({
          name  : (this.$route.path.substr(0,3) === '/es') ? 'es-routes-all' : 'routes-all',
          params: { routeOrLink: routeType, routeNo: routeNo}
        });
    },
    showLegSteps (legIndex) {
      if (!this.selectedTrip && this.legStepsToggled.length > 0) {
        return
      }
      // if (this.legs.length > 0 && this.legStepsToggled.length < 1) {
      //   this.legStepsToggled = this.legs.map(x => false)
      // }
      // clone to make array reactive
      let legs = [...this.legStepsToggled]
      legs[legIndex] = !legs[legIndex]
      this.legStepsToggled = legs
    }
  },
  mounted () {
    // load modal popup upon route detail/trip planner result page load
    if (jQuery('#mailchimpModal').length > 0) {
      jQuery('#mailchimpModal').modal('show');
    }
  }
}
</script>

<style lang="scss" scoped>
.card {
  border-radius: 0;
}
.line-no {
  margin-left: 3px;
  padding: 2px;
}

.mode-details {
  padding:5px 5px 5px 2px;
  display: inline-block;
}
.mode-details:hover {
  background-color: #aaa;
  // color: #fff;
  cursor: pointer;
}

.table td, .table th {
  padding: .5rem;
  border-top: solid 0px #000;
}

td.start-time {
  width: 75px;
}

td.circle-line {
  height: 1px;
  width:5px;
  padding-top: 5px;
}
.circle-line-divwrapper {
  position: relative;
  height: 100%;
}
.circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
  border: 2px solid rgb(86, 184, 233);
  background-color: #fff;
  z-index: 9;
  margin-top: 12px;
  display: inline-block;
  position: relative;
}

.line {
  z-index: 1;
  position: absolute;
  border-left: 3px solid rgb(86, 184, 233);
  // background-color: rgb(86, 184, 233);
  // width: 2px;
  left: 4px;
  // right: 4px;
  // margin-left: 4px;
  top: 15px;
  bottom: -35px;
}
.line-walk {
  border-left: 3px dashed rgb(86, 184, 233);
}

.list-group-item {
  padding-left: 0;
  border:solid 0px #000;
  margin-bottom: 0;
  border-bottom: 1px solid rgba(0,0,0,.125);
}

.leg-steps {
  font-size:12px;
}

.rotate180 {
  -webkit-transform: rotate(180deg);     /* Chrome and other webkit browsers */
  -moz-transform: rotate(180deg);        /* FF */
  -o-transform: rotate(180deg);          /* Opera */
  -ms-transform: rotate(180deg);         /* IE9 */
  transform: rotate(180deg);             /* W3C compliant browsers */

  /* IE8 and below */
  filter: progid:DXImageTransform.Microsoft.Matrix(M11=-1, M12=0, M21=0, M22=-1, DX=0, DY=0, SizingMethod='auto expand');
}

tr {
  transition: all 0.2s ease-in;
  background-color: #fff;
}
tr:hover {
  background-color: #eee;
}


.icon-icon-light-rail {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/TripPlannerResultsDetails.vue